<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Send to Case</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div class="row mb-3">
    <label class="col-sm-3 col-form-label fw-semibold">Selected File</label>
    <div class="col-sm-9 col-form-label">{{file.fileName}}</div>
  </div>

  <div class="row mb-3">
    <label class="col-sm-3 col-form-label fw-semibold">New File Name</label>
    <div class="col-sm-9">
      <input class="form-control" [(ngModel)]="newFileName" (change)="validateForm()" autocomplete="off">
    </div>
  </div>

  <div class="row mb-3">
    <label class="col-sm-3 col-form-label fw-semibold">Search Cases</label>
    <div class="col-sm-9">
      <form [formGroup]="form">
        <input type="text" class="form-control ms-0" placeholder="Search Cases" formControlName="search"
          [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
          <mat-option *ngIf="isSearching" disabled>
            <span class="spinner-border spinner-border-sm" role="status"></span>
            Searching...
          </mat-option>
          <ng-container *ngIf="!isSearching">
            <mat-option *ngFor="let case of filteredItems" [value]="case" (click)="selectCase(case)">
              {{ case.caseTypeName }} - {{ case.caseReference }} - {{ case.partyOneFirstName }}
              {{ case.partyOneLastName }} - {{case.partyOnePostcode}} - {{ case.caseStatusTypeText }}
            </mat-option>
          </ng-container>
        </mat-autocomplete>
      </form>
    </div>
  </div>

  <div class="row mb-3" *ngIf="selectedCase">
    <label class="col-sm-3 col-form-label fw-semibold">Selected Case</label>
    <div class="col-sm-9 col-form-label">
      {{ selectedCase.caseTypeName }} - {{ selectedCase.caseReference }} - {{ selectedCase.partyOneFirstName }}
      {{ selectedCase.partyOneLastName }} - {{selectedCase.partyOnePostcode}} - {{ selectedCase.caseStatusTypeText }}
    </div>
  </div>

</div>

<div class="modal-footer">

  <button *ngIf="!sendingToCase" type="button" class="btn btn-success"
    [disabled]="sendToCaseDisabled" (click)="sendToCase()">
    Send to Case
  </button>

  <button *ngIf="sendingToCase" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Sending...
  </button>
</div>